import { Component } from 'react';
import { connect } from 'react-redux';

import { HYDRA_VIP_BADGE_MULTIPLIER } from 'constants/hydraTests';
import { evRecommendationClick } from 'events/recommendations';
import { isAssigned, triggerAssignment } from 'actions/ab';
import { track } from 'apis/amethyst';
import VipOnlyLogo from 'components/icons/vipDashboard/VipOnlyLogo';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardCategory from 'components/common/melodyCard/MelodyCardCategory';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import marketplace from 'cfg/marketplace.json';

import css from 'styles/components/landing/melodyPersonalizedBrand.scss';

const widgetType = 'BRAND_RECOMMENDATION_WIDGET';
const recommendationSource = 'ZAPPOS_DATA_SCIENCE';
const recommendationType = 'BRAND_RECOMMENDATION';

export class MelodyPersonalizedBrand extends Component {
  componentDidMount() {
    this.props.triggerAssignment(HYDRA_VIP_BADGE_MULTIPLIER);
  }

  handleClick = (e, index, id) => {
    const { onComponentClick } = this.props;
    onComponentClick(e);
    track(() => ([
      evRecommendationClick, {
        index,
        recommendationType,
        recommendationValue: id,
        recommendationSource,
        widgetType
      }
    ]));
  };

  makeHeadingText = isTrending => {
    const { firstName } = this.props;
    if (isTrending) {
      return 'Trending Brands';
    }
    return firstName ?
      `${firstName}, You Might Like These Brands` :
      'Brands For You';
  };

  makeBrandPromo = () => (
    <p className={css.brandPromo}>
      <VipOnlyLogo />
      Bonus Points
    </p>
  );

  render() {
    const {
      slotName,
      slotDetails: { brands, monetateId },
      shouldLazyLoad,
      hydraVipBadgeMultiplier
    } = this.props;
    const { desktopBaseUrl } = marketplace;

    if (brands && brands.length) {
      const recoSource = brands[0].recommendationSource;
      const isTrending = recoSource && recoSource === 'TRENDING_BRANDS';

      return (
        <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
          <h2 className={css.heading}>
            {this.makeHeadingText(isTrending)}
          </h2>
          <MelodyCarousel>
            {brands.map((brand, index) => {
              const { headerImageUrl, name, cleanName, id, brandUrl, brandPromo } = brand;
              const link = brandUrl || `/search/null/filter/brandNameFacet/${encodeURIComponent(name)}`;
              const cardData = {
                image: `${desktopBaseUrl}${headerImageUrl}`,
                name,
                alt: name,
                gae: cleanName,
                link
              };

              return (
                <MelodyCardCategory
                  cardData={cardData}
                  eventLabel="melodyPersonalizedBrand"
                  melodyCardTestId="melodyPersonalizedBrand"
                  onComponentClick={e => {
                    this.handleClick(e, index, id);
                  }}
                  shouldLazyLoad={shouldLazyLoad}
                  key={id}>
                  { (brandPromo && hydraVipBadgeMultiplier) && this.makeBrandPromo() }
                </MelodyCardCategory>
              );
            })}
          </MelodyCarousel>
        </div>
      );
    }
    return false;
  }
}

function mapStateToProps(state) {
  return {
    firstName: state.holmes.firstName,
    hydraVipBadgeMultiplier: isAssigned(HYDRA_VIP_BADGE_MULTIPLIER, 1, state)
  };
}

const ConnectedMelodyPersonalizedBrand = connect(mapStateToProps, {
  triggerAssignment
})(MelodyPersonalizedBrand);
export default withErrorBoundary('MelodyPersonalizedBrand', ConnectedMelodyPersonalizedBrand);
